import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt';
import RTL from './Components/RTL';
import useSettings from './Context/Hooks/useSettings';
import { createGatewayTheme } from './Assets/theme/gatewayTheme';
import SettingsDrawer from "./Components/SettingsDrawer";
import { Routes } from './Routes/routes'
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

function App() {
  const { settings } = useSettings();
  const theme = createGatewayTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    language: i18n.language,
  });

  window.platform_name = process.env.REACT_APP_PLATFORM_NAME;

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider
dateAdapter={AdapterDateFns}
adapterLocale={ptLocale}
      >
      <RTL direction={settings.direction}>
        <CssBaseline />
        <Toaster
          toastOptions={{
            success: {
              style: {
                background: theme.palette.success.main,
                color: theme.palette.success.contrastText
              },
              iconTheme: {
                primary: theme.palette.success.contrastText,
                secondary: theme.palette.success.main,
              }
            },
            error: {
              style: {
                background: theme.palette.error.main,
                color: theme.palette.error.contrastText
              },
              iconTheme: {
                primary: theme.palette.error.contrastText,
                secondary: theme.palette.error.main,
              },
            },
          }}
          position="top-right"
        />
        <SettingsDrawer />
        <I18nextProvider i18n={i18n}>
          {Routes()}
        </I18nextProvider>
      </RTL>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
